import AuctionTypes from './AuctionTypes';

export const getSpotBidSearchResultsProgress = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_SEARCH_RESULTS_PROGRESS,
    payload,
  };
};

export const getSpotBidSearchResultsError = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_SEARCH_RESULTS_ERROR,
    payload,
  };
};

export const getSpotBidSearchResultsSuccess = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_SEARCH_RESULTS_SUCCESS,
    payload,
  };
};

export const setTotalSpotBidCount = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_TOTAL_COUNT,
    payload,
  };
};

export const setSelectedSpotBid = (payload) => {
  return {
    type: AuctionTypes.SET_SELECTED_SPOTBID,
    payload,
  };
};

export const setSpotBidSearchResults = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_SEARCH_RESULTS,
    payload,
  };
};

export const setSearchFilters = (payload) => {
  return {
    type: AuctionTypes.SET_SEARCH_FILTERS,
    payload,
  };
};

export const getShipmentProductDetailProgress = (payload) => {
  return {
    type: AuctionTypes.GET_SHIPMENT_PRODUCT_DETAIL_PROGRESS,
    payload,
  };
};

export const getShipmentProductDetailError = (payload) => {
  return {
    type: AuctionTypes.GET_SHIPMENT_PRODUCT_DETAIL_ERROR,
    payload,
  };
};

export const getShipmentProductDetailSuccess = (payload) => {
  return {
    type: AuctionTypes.GET_SHIPMENT_PRODUCT_DETAIL_SUCCESS,
    payload,
  };
};

export const setSpotBidSaveProgress = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_SAVE_PROGRESS,
    payload,
  };
};

export const setSpotBidSaveSuccess = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_SAVE_SUCCESS,
    payload,
  };
};

export const setSpotBidSaveError = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_SAVE_ERROR,
    payload,
  };
};

export const setSpotBidDeclineProgress = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_DECLINE_PROGRESS,
    payload,
  };
};

export const setSpotBidDeclineSuccess = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_DECLINE_SUCCESS,
    payload,
  };
};

export const setSpotBidDeclineError = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_DECLINE_ERROR,
    payload,
  };
};

export const getShipmentDocumentsListInProgress = (payload) => {
  return { type: AuctionTypes.GET_DOCUMENTS_PROGRESS, payload };
};

export const getShipmentDocumentsListInSuccess = (payload) => {
  return { type: AuctionTypes.GET_DOCUMENTS_SUCCESS, payload };
};

export const getShipmentDocumentsListInError = (payload) => {
  return { type: AuctionTypes.GET_DOCUMENTS_ERROR, payload };
};

export const getQuoteMultiStopInProgress = (payload) => {
  return { type: AuctionTypes.GET_MULTI_QUOTE_PROGRESS, payload };
};

export const getQuoteMultiStopInSuccess = (payload) => {
  return { type: AuctionTypes.GET_MULTI_QUOTE_SUCCESS, payload };
};

export const getQuoteMultiStopInError = (payload) => {
  return { type: AuctionTypes.GET_MULTI_QUOTE_ERROR, payload };
};

export const setSpotBidSaveStatusDefault = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_SAVE_STATUS_DEFAULT,
    payload,
  };
};

export const getSpotBidExportSearchResultsProgress = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_EXPORT_SEARCH_RESULTS_PROGRESS,
    payload,
  };
};

export const getSpotBidExportSearchResultsError = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_EXPORT_SEARCH_RESULTS_ERROR,
    payload,
  };
};

export const getSpotBidExportSearchResultsSuccess = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_EXPORT_SEARCH_RESULTS_SUCCESS,
    payload,
  };
};

export const getSpotBidResultsAfterSubmitProgress = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_RESULTS_SUBMIT_PROGRESS,
    payload,
  };
};

export const getSpotBidResultSubmitSuccess = (payload) => {
  return {
    type: AuctionTypes.GET_SPOTBID_LIST_SUMBIT_SUCCESS,
    payload,
  };
};

export const setDefaultSpotBidSearchList = (payload) => {
  return {
    type: AuctionTypes.SET_SPOTBID_VALUE_DEFAULT,
    payload,
  };
};
